export const label = {

    // common
    search: 'Search',

    // header
    automationService: 'Industry Services',
    portal: 'Portal',
    activeLicense: 'Active License',
    licenseExpired: 'License Expired',
    gracePeriod: 'Grace Period',
    tenantUser: 'Tenant Users',
    logout: 'Logout',
    profileUpdate: 'Profile Update',
    changePassword: 'Change Password',
    changeEmail: 'Change Email',
    schneiderElectric: 'schneider electric',

    // sidenav
    home: 'Home',
    about: 'About',
    settings: 'Settings',

    // shell

    // tabbar
    overview: 'OVERVIEW',
    versionUpdate: 'VERSION UPDATE',
    support: 'SUPPORT',
    dashboard: 'STATISTICS',

    // overview
    assessmentquotation: 'ASSESSMENT & QUOTATIONS',
    applicationretrofit: 'APPLICATION RETROFIT',
    engineeringsuite: 'ENGINEERING SUITE',
    viewTool: 'View tool',
    requestAccess: 'Request Access',
    requestInitiated: 'Request Initiated',
    moreInfo: 'More info',
    lessInfo: 'Less info',
    noApplicationData: 'No application data',
    dragDropHere:'Drag and drop zip or exe file here or click to browse',
    uploadsoftware: 'Upload Software',
    upload: 'Upload',
    download:'Download',
    uploadSoftware: 'Upload Software',
    appNameVersion:'ApplicationName and Version',
    action:'Action',
    dateTime:'Date and Time (UTC)',
    uploadMsg:'Upload in progrees please do not close the window',
    downloadMsg:'Download in progrees please do not close the window',
    fileNote: 'Please scan the file before uploading. Only .zip, .exe files allowed',
    // pop-up
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    move: 'Move',
    requestSubLabel: 'Are you sure you want to request an access to this tool?',
    requestSecondLabel: 'Add few words about on why you need this tool. This will help us to give you a better support.',
    typeHere: 'Type here...',

    requestInitiatedSuccessfully: 'Request initiated successfully',
    blocked: 'Blocked',
    unblock: 'Unblock',
    unblockText: 'Your account is blocked',
    errorDownloadtryagain: 'Error in Downloading. Try again',
    errorUploadTryAgain:'Error in uploading. Try again',
    errorgetDefaultFile:'Error in fetching default file. Try again',

    // Terms and conditions
    termsTitle:'Industry Service Portal - Terms & Conditions',
    readText: 'Please read and accept our Terms & Conditions and Privacy Policy.',
    checkBelow: 'You can check the below links',
    termsCondition: 'Terms & Conditions',
    privacyPolicy: 'Privacy Policy',
    agreeTerms: 'I agree with Terms and Conditions',
    agreePolicy: 'I agree with Privacy Policy',
    accept: 'Accept',
    decline: 'Decline',
    errorFetchingDataReloading: 'Error in fetching data. Try reloading the application',
    errorUpdationTryAgain: 'Error in updation. Try again',
    // Footer text
    footerCopyright: ' Schneider Electric',
    enterDescription: 'Please add the description',
    knowMore: 'Know More',
    errorTxtEnterValue: 'Please add the description',

    updateSuccessfully: 'Updated Succesfully',
    updateOffer: 'Update Offers',
    confirmMessage: 'Are you sure you want to save the changes ?',
    yes: 'Yes',
    no: 'No',
    // Admin Dashboard
    tikets: 'Tickets',
    closed: 'Closed',
    open:'Open',
    high: 'High',
    medium: 'Medium',
    low: 'Low',
    totalUsers:'Total Number Of Users',
    accessedApps: 'Applications User Access Count',
    appDownloads: 'Applications Download Count',
    allApplications: 'All Applications',
    detailedAnalysis: 'Analasys',
    numberofUserswrtApp: 'Number Of Users With Respect To Application',
    usersCount: 'Service Portal Users Count',
    usersAppAccessdata: 'Users Application Access Data',
    usersAppdownloaddata:'Users Application Downloaded Data',
    addIssue: 'Add Ticket',
    add: 'Add',
    addscreens:'Upload files if any (File size should be less than 10 MB, maximum 5 files allowed)',
    issueTitle: 'Ticket Title',
    issueDesc: 'Ticket Description',
    issuePriority: 'Priority',
    uploadFile: 'Upload File(s)',
    confirmDelete: 'Are you sure you want to delete the ticket ?',
    addTicket: 'Add New Ticket',
    attachedScreens: 'Attached File(s)', 
    confirmResolve: 'Are you sure you want to resolve the ticket ?',
    ticket_Identifier: ' SP-',
    confirmReOpen:'Are you sure you want to reopen the ticket ?',
    imageFormats:'.jpg, .jpeg, .png',
    deleteTicket: 'Delete Ticket',
    ticketDetails:'Ticket Details',
    status:'Status',
    createdBy: 'Created by',
    attachedFiles:'Attached Files',
    comments:'Comments',
    noComments: 'No Comments Added yet.',
    addComment:'Add Comment',
    reOpenTicket: 'Reopen Ticket',
    resolveTicket: 'Resolve Ticket',
    ticketCreated: 'Ticket successfully created',
    resolutionSuccess: 'Ticket resolved successfully',
    reOpenSuccess: 'Ticket reopened successfully',
    assignmentSuccess: 'Ticket assigned successfully',
    fetcherrTicket:'Error in fetching tickets',
    fetcherrAttachment:'Error in fetching attachments',
    fetcherrComments:'Error in fetching comments',
    createTicketErr: 'Error in creating ticket',
    maxFileErr: 'Maximum of 5 files can be uploaded',
    wrongFileTypeErr:'Wrong file type selected',
    errResolve:'Error in resolving ticket',
    errReOpen:'Error in reopening ticket',
    errDownload:'Error in downloading file',
    errDownloadTicket:'Error in downloading tickets',
    errAssign:'Error in assigning ticket',
    downloadWarning:'Please scan the downloaded file before executing',
    note:'Note',
    close :'Close',
    itemsDisplayed: 'items displayed',
    gridView : "Grid View",
    chartView : "Chart View",
    active:"Active",
    pending:"Pending",
    approved:"Approved",
    name: "Name",
    applictaionName:"Application Name",
    fileName:"File Name",
    DownloadedOn:"downloaded On",
    access:"Access",
    servicePortal: "Service Portal",
    all:"All",
    termsAndConditions:"Terms and Conditions",
    ticketId:"Ticket Id",
    assignedTo:"Assigned To",
    title:"Title",
    createdOn:"Created On(UTC Time)",
    description:"Description",
    email:"Email",
    iA3:"IA3",
    plcConverter:"PLC Converter",
    migrationExpert:"Migration Expert",
    ok: "OK"
}